var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Star, StarFill } from "@gravity-ui/icons";
import { Button, Flex, Icon } from "@gravity-ui/uikit";
import { ConfirmModal } from "@/components/modal/ConfirmModal";
import { PageBlock } from "@/components/ui/PageBlock";
import UserCard from "@/components/ui/UserCard";
import { useAuthContext } from "@/context/useAuthContext";
import { RoutesList } from "@/router/routesList";
import { useAddUserToFavoritesMutation, useRemoveUserFromFavoritesMutation, } from "@/store/api";
export var UserDetails = function (props) {
    var _a, _b;
    var user = useAuthContext().user;
    var _c = useAddUserToFavoritesMutation(), addUserToFavoritesAction = _c[0], addUserToFavoritesState = _c[1];
    var _d = useRemoveUserFromFavoritesMutation(), removeUserFromFavoritesAction = _d[0], removeUserFromFavoritesState = _d[1];
    var handleToggleFavorite = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 5, , 6]);
                    if (!((_a = props.data.meta) === null || _a === void 0 ? void 0 : _a.isFavorite)) return [3 /*break*/, 2];
                    return [4 /*yield*/, removeUserFromFavoritesAction({
                            favoriteId: props.data.id,
                        }).unwrap()];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, addUserToFavoritesAction({ favoriteId: props.data.id }).unwrap()];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    error_1 = _b.sent();
                    console.error(error_1);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var navigate = useNavigate();
    var isLoadingFavoriteAction = addUserToFavoritesState.isLoading || removeUserFromFavoritesState.isLoading;
    var _e = useState(0), favoriteIconKey = _e[0], setFavoriteIconKey = _e[1];
    useEffect(function () {
        setFavoriteIconKey((addUserToFavoritesState.fulfilledTimeStamp || 0) +
            (removeUserFromFavoritesState.fulfilledTimeStamp || 0));
    }, [
        addUserToFavoritesState.fulfilledTimeStamp,
        removeUserFromFavoritesState.fulfilledTimeStamp,
    ]);
    // Окно подтверждения удаления юзера
    var _f = useState(false), deleteUserOpen = _f[0], setDeleteUserOpen = _f[1];
    var deleteUserHandler = function () {
        setDeleteUserOpen(true);
    };
    var confirmDeleteHandler = function () {
        setDeleteUserOpen(false);
        props.onDeleteClick();
    };
    var cancelDeleteHandler = function () {
        setDeleteUserOpen(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx(UserCard, { user: props.data }), user.id !== props.data.id ? (_jsx(PageBlock, { isCard: true, children: _jsxs(Flex, { gap: 4, children: [_jsxs(Button, { view: "outlined", loading: isLoadingFavoriteAction, onClick: handleToggleFavorite, children: [_jsx(Icon, { data: ((_a = props.data.meta) === null || _a === void 0 ? void 0 : _a.isFavorite) ? StarFill : Star, size: 18 }, favoriteIconKey), ((_b = props.data.meta) === null || _b === void 0 ? void 0 : _b.isFavorite)
                                    ? "Удалить из избранного"
                                    : "Добавить в избранное"] }), !!props.onEditClick && (_jsxs(_Fragment, { children: [_jsx(Button, { view: "action", onClick: props.onEditClick, children: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C" }), _jsx(Button, { view: "flat-danger", onClick: deleteUserHandler, children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" })] }))] }) })) : (_jsx(PageBlock, { isCard: true, children: _jsx(Button, { view: "action", onClick: function () { return navigate(RoutesList.Profile.getUserProfile()); }, children: "\u041F\u0440\u043E\u0444\u0438\u043B\u044C" }) })), _jsx(ConfirmModal, { open: deleteUserOpen, onConfirm: confirmDeleteHandler, onClose: cancelDeleteHandler, children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F" })] }));
};
